<div *ngIf="dataSource != null" class="w-full pt-2">
    <table mat-table [dataSource]="dataSource" matSort class="w-full font-normal text-base p-0">
        <!-- Company Name Column -->
        <ng-container matColumnDef="CompanyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading">
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_COMPANY_NAME"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.requestToName }}
            </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="Role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_ROLE"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.Status }}
            </td>
        </ng-container>

        <!-- Supplier ID Column -->
        <ng-container matColumnDef="Supplier ID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_SUPPLIER_ID"  | translate }} 
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.name }}
            </td>
        </ng-container>

        <!-- Walmart Mill ID Column -->
        <ng-container matColumnDef="Walmart Mill ID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_WALMART_MILL_ID"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.name }}
            </td>
        </ng-container>


        <!-- Country Column -->
        <ng-container matColumnDef="countryName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_COUNTRY_NAME"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.countryName }}
            </td>
        </ng-container>

        <!-- Date Of Request Column -->
        <ng-container matColumnDef="requestDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_HEADER_DATE_OF_REQUEST"  | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
                {{ row.createdDate | date:'dd.MM.y' }}
            </td>
        </ng-container>

        <!-- Connection Status Column -->
        <ng-container matColumnDef="ConnectionStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="items-center table-heading">
                Connection Status
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon svgIcon="heroicons_solid:filter" class="pt-1 pb-0 items-center"></mat-icon>
                </button>

                <mat-menu #menu="matMenu" yPosition="below">
                    <button (click)="onStatusFilterChnage(-1)"
                        [ngStyle]="{'font-weight' : statusFilter == -1 ? 'bold' : 'normal' }" mat-menu-item>
                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.ALL"  | translate }}
                    </button>

                    <button (click)=" onStatusFilterChnage(0)"
                        [ngStyle]="{'font-weight' : statusFilter == 0 ? 'bold' : 'normal' }" mat-menu-item>
                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.PENDING"  | translate }}
                    </button>

                    <button (click)=" onStatusFilterChnage(2)"
                        [ngStyle]="{'font-weight' : statusFilter == 2 ? 'bold' : 'normal' }" mat-menu-item>
                        {{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.DECLINED"  | translate }}
                    </button>

                </mat-menu>



            </th>

            <td mat-cell *matCellDef="let row">
                <p *ngIf="row.status == 0" class="text-gray-500">
                    <em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.PENDING"  | translate }}</em>
                </p>
                <p *ngIf="row.status == 1" style="color: green">
                    <em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.CONNECTED"  | translate }}</em>
                </p>
                <p *ngIf="row.status == 2" style="color: red">
                    <em>{{ "BRAND_FACTORY_CONNECTION_COMPONENT.REQUEST_STATUS.DECLINED"  | translate }}</em>
                </p>
            </td>
        </ng-container>

         <!-- delete Column -->
         <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-heading" >
                Action
            </th>
            <td mat-cell *matCellDef="let row">
               <mat-icon (click)="deleteConnectionRequest(row.id)">delete_outline</mat-icon>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">
                {{ "BRAND_FACTORY_CONNECTION_COMPONENT.TABLE_NO_DATA_MATCHING_FILTER"  | translate }}
            </td>
        </tr>
    </table>

    <mat-paginator [length]="totalCount" [pageSizeOptions]="[ 5, 10, 25, 100]" (page)="onPageChange($event)"
        class="pb-2"></mat-paginator>
</div>